import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "deleteModal",
    "deleteLogsModal",
    "foodTaxonomyField",
    "recurrence",
    "submitTaskLog",
    "weightField",
  ];
  static values = { recurrence: Boolean, hasLogs: Boolean };

  // This is somewhat coupled with the show page. If there are no logs and it's
  // a single event, there is no button to invoke either modal. But the presence
  // of logs or a recurring event will open it.
  openDeleteModal() {
    if (this.recurrenceValue) {
      new mdc.dialog.MDCDialog(this.deleteModalTarget).open();
    } else if (this.hasLogsValue) {
      new mdc.dialog.MDCDialog(this.deleteLogsModalTarget).open();
    }
  }

  validateTaskLogForm() {
    const taxonomy = this.foodTaxonomyFieldTarget.value;
    const weight = this.weightFieldTarget.value;
    const taxonomyValid = this.isInt(taxonomy) && Number(taxonomy) > 0;
    // weights can be 0 meaning nothing happened, but we still want to record it
    const weightValid = this.isInt(weight) && Number(weight) >= 0;

    if (taxonomyValid && weightValid) {
      this.submitTaskLogTarget.disabled = false;
    } else {
      this.submitTaskLogTarget.disabled = true;
    }
  }

  isInt(input) {
    return !isNaN(parseInt(input));
  }
}
